import React, {
    useEffect,
    useState,
} from "react";

import {
    Stack,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";

import { useDispatch } from "react-redux";

import {
    updateAgentServiceAction,
    fetchAgentServicesAction,
} from "state/actions/agentServiceActions";

import {
    useCustomNotification,
} from "components/Toasts/OpenNotification";


const EditAgentService = ({
    isOpen,
    onClose,
    service,
}) => {

    const dispatch = useDispatch();

    const notify =
        useCustomNotification();


    const [
        name,
        setName,
    ] = useState("");


    const [
        description,
        setDescription,
    ] = useState("");


    const [
        isActive,
        setIsActive,
    ] = useState(true);


    const [
        submitting,
        setSubmitting,
    ] = useState(false);


    useEffect(() => {

        if (service) {

            setName(
                service.name ||
                ""
            );

            setDescription(
                service.description ||
                ""
            );

            setIsActive(
                service.is_active ??
                true
            );

        }

    }, [service]);


    const handleSubmit =
        async () => {

            if (
                !service?.service_id
            ) {

                notify({
                    message:
                        "Service Missing",

                    description:
                        "Unable to identify the service.",

                    type:
                        "error",
                });

                return;
            }


            if (!name.trim()) {

                notify({
                    message:
                        "Service Name Required",

                    description:
                        "Please enter a service name.",

                    type:
                        "error",
                });

                return;
            }


            if (!description.trim()) {

                notify({
                    message:
                        "Description Required",

                    description:
                        "Please enter a service description.",

                    type:
                        "error",
                });

                return;
            }


            setSubmitting(true);


            const payload = {

                name:
                    name.trim(),

                description:
                    description.trim(),

                is_active:
                    isActive,

            };


            const response =
                await dispatch(
                    updateAgentServiceAction(
                        service.service_id,
                        payload
                    )
                );


            setSubmitting(false);


            if (
                response.success
            ) {

                notify({
                    message:
                        "Service Updated",

                    description:
                        "Agent service updated successfully.",

                    type:
                        "success",
                });


                dispatch(
                    fetchAgentServicesAction()
                );


                onClose();

            } else {

                notify({
                    message:
                        "Failed to Update Service",

                    description:
                        response.error ||
                        "Something went wrong while updating the service.",

                    type:
                        "error",
                });

            }
        };


    return (

        <ReusableDrawer

            isOpen={
                isOpen
            }

            onClose={
                onClose
            }

            headerContent={
                <h2>
                    Edit Agent Service
                </h2>
            }

            bodyContent={

                <Stack
                    spacing={5}
                >

                    <ReusableInput

                        label="Service Name"

                        placeholder="Enter service name"

                        value={
                            name
                        }

                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }

                        isRequired

                    />


                    <ReusableInput

                        label="Description"

                        placeholder="Enter service description"

                        value={
                            description
                        }

                        onChange={(e) =>
                            setDescription(
                                e.target.value
                            )
                        }

                        type="textarea"

                        isRequired

                    />


                    {/* <ReusableInput

                        label="Active"

                        type="checkbox"

                        value={
                            isActive
                        }

                        onChange={(e) =>
                            setIsActive(
                                e.target.checked
                            )
                        }

                    /> */}

                </Stack>

            }

            footerContent={

                <Stack
                    direction="row"
                    spacing={4}
                    justifyContent="flex-end"
                >

                    <GradientButton
                        width="100px"
                        height="40px"
                        onClick={
                            onClose
                        }
                    >
                        Cancel
                    </GradientButton>


                    <GradientButton
                        width="120px"
                        height="40px"
                        onClick={
                            handleSubmit
                        }
                        isLoading={
                            submitting
                        }
                    >
                        Save
                    </GradientButton>

                </Stack>

            }

        />

    );
};


export default EditAgentService;